import { render, staticRenderFns } from "./SelectVehicle.vue?vue&type=template&id=5c4bd3ad&"
import script from "./SelectVehicle.vue?vue&type=script&lang=js&"
export * from "./SelectVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports